module.exports = __webpack_public_path__ + "static/img/3.f72cd53.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/4/zh/3.png
// module id = GyIa
// module chunks = 0